import { Component, OnInit } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-fundrich-layout',
  templateUrl: './fundrich-layout.component.html',
  styleUrls: ['./fundrich-layout.component.scss']
})
export class FundrichLayoutComponent implements OnInit {

  index = environment.FUNDRICH_INDEX_URL;

  constructor(private baseService: BaseService) { }

  ngOnInit(): void {
    this.baseService.info.indexUrl = this.index;
  }

}
